<div *ngIf="prop">
  <!-- content -->
  <div *ngIf="!noCategoryVisible; else noDocAccess" class="d-flex flex-row align-items-center">
    <mat-form-field (keyup)="applyGlobalFilter(filter.value)">
      <mat-icon matPrefix color="primary">search</mat-icon>
      <mat-label>Rechercher</mat-label>
      <input #filter matInput placeholder="" type="text" />
    </mat-form-field>
    <div class="spacer"></div>
    <button *ngIf="canShowDownload" mat-mini-fab appTooltip="Télécharger tous les documents du bien"
      class="btn-download ml-auto" color="primary" (click)="downloadDocuments()" [disabled]="downloadDisabled">
      <mat-icon aria-label="Télécharger tous les documents du bien">file_download</mat-icon>
    </button>
  </div>
  <mat-accordion multi="true">
    <ng-container *ngFor="let data of docCategories">
      <mat-expansion-panel *ngIf="data.visible" [expanded]="data.expanded">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ data.name }}</mat-panel-title>
          <mat-panel-description>
            {{ data.description }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <app-vault-doc-table [prop]="prop" [category]="data.category" (docUpdated)="refreshDocList()">
          </app-vault-doc-table>
        </ng-template>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
  <ng-template #noDocAccess>
    <span class="no-content">Aucun document n'est accessible</span>
  </ng-template>
</div>
